var _style, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 512",
    style: {
      enableBackground: "new 0 0 576 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:7;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.1,3.1L60.3,82.6c-19,7.1-31.7,25.5-31.7,45.8v229.2c0,18.5,10.5,35.4,27,43.7l211.8,105.9 c13.7,6.9,29.9,6.9,43.7,0L523,401.3c16.6-8.2,27-25.3,27-43.7V128.4c0-20.4-12.6-38.6-31.7-45.7L306.5,3.2 C295.5-1.1,283.2-1.1,272.1,3.1z M289.4,31.5l228.1,85.5v0.3l-228.1,98.9L61.2,117.4v-0.3C61.2,117.1,289.4,31.5,289.4,31.5z  M61.2,152.9l211.8,91.8v228.8L61.2,367.6V152.9z M305.6,473.5V244.7l211.8-91.8v214.8L305.6,473.5L305.6,473.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 241,
    width: 27,
    height: 104
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.34dbde1263024750709ca78c2b5b7c80.svg";
export { ForwardRef as ReactComponent };